import { defineStore } from "pinia";

export const useChromeStore = defineStore("chrome", () => {
  const registeredModals = ref<string[]>([]);
  const visibleModals = ref<string[]>([]);
  const searchVisible = ref(false);
  let toggleInProgress = false;

  function toggleSearch() {
    if (toggleInProgress) return;
    toggleInProgress = true;

    searchVisible.value = !searchVisible.value;

    nextTick(() => {
      toggleInProgress = false;
    });
  }

  function closeSearch() {
    searchVisible.value = false;
  }

  return {
    blockUI: computed(() => visibleModals.value.length > 0),
    unblock: () => (visibleModals.value = []),
    notificationActive: computed(() => visibleModals.value.length),
    visibleModals,
    registeredModals,
    register: (id: string) => (registeredModals.value = [...registeredModals.value, id]),
    unregister: (id: string) => (registeredModals.value = registeredModals.value.filter((_id) => _id !== id)),
    searchVisible,
    toggleSearch,
    closeSearch,
  };
});
